// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"f2b3ce0f","600":"88586e0b","663":"b2d9450f"}[chunkId] + ".chunk.css";
};